<template>
  <div class="home">
    <!-- <MainContent />
    <ChooseUs /> -->
    <BodyPage />
  </div>
</template>

<script>
// @ is an alias to /src
// import MainContent from '@/components/MainContent.vue'
// import ChooseUs from '@/components/ChooseUs.vue'
import BodyPage from '@/components/BodyPage.vue';

export default {
  name: 'HomeView',
  components: {
    BodyPage
    // MainContent,
    // ChooseUs
  }
}
</script>
